import { useState, useEffect } from "react";

const useGeoLocation = (
	{ enableHighAccuracy, maximumAge, timeout } = {},
	callback
) => {
	const [location, setLocation] = useState({
		loaded: false
	});

	useEffect(() => {
		let didCancel;

		const updateCoordinates = location => {
			if (!didCancel) {
				setLocation({
					loaded: true,
					coords: {
						lat: location.coords.latitude,
						lng: location.coords.longitude
					},
					accuracy: location.coords.accuracy,
					timestamp: location.timestamp
				});
			} else {
				console.log("User has canceled position");
			}
		};

		const setError = error => {
			if (!didCancel) {
				// @todo: this function isn't defined anywhere?
				// setCoordinates({
				// 	accuracy: null,
				// 	altitude: null,
				// 	altitudeAccuracy: null,
				// 	heading: null,
				// 	latitude: null,
				// 	longitude: null,
				// 	speed: null,
				// 	timestamp: null,
				// 	error
				// });
			}
		};

		let watchId;
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				updateCoordinates,
				setError
			);
			watchId = navigator.geolocation.watchPosition(
				updateCoordinates,
				setError,
				{ enableHighAccuracy, maximumAge, timeout }
			);
		}
		return () => {
			if (watchId) {
				navigator.geolocation.clearWatch(watchId);
			}
			didCancel = true;
		};
	}, [callback, enableHighAccuracy, maximumAge, timeout]);

	return location;
};

export default useGeoLocation;
